@let _classes = classes();
@let _textClasses = textClasses();
@let _tag = tag.value();
@let _icon = icon();
@let _flex = flex();
@let _image = image();
@let _textColorClass = defaultTextClasses();

<div
  class="flex flex-row rounded-sm px-1 py-0 leading-[0] {{
    _tag?.color ? '' : _classes ? '' : 'bg-slate-400'
  }} {{ _classes }} text-center"
  [ngClass]="{
    'flex-1 items-center justify-center': _flex
  }"
  [ngStyle]="{ 'background-color': _tag?.color || null }"
>
  @if (tag.isLoading() || !_tag) {
    <span class="text-slate-600 text-xs">...</span>
  } @else {
    @if (_image) {
      <img [src]="_image" crossorigin class="rounded-full h-7 w-7" />
    }

    @if (_icon) {
      <i class="{{ _icon }} {{ _textColorClass }} text-xs"></i>&nbsp;
    }

    <span
      class="{{
        _textClasses ? _textClasses : _textColorClass
      }} text-xs font-bold"
      [ngClass]="{
        'ml-auto': !_flex,
        uppercase: uppercase()
      }"
      >{{ _tag.label }}</span
    >

    @if (enableDxTagRemoveButton()) {
      <div
        class="dx-tag-remove-button"
        class="relative self-center {{ _textColorClass }} before:content-none"
      >
        <i class="fa-light fa-xmark"></i>
      </div>
    }
  }
</div>
